import { pxToRem } from '@mos-cat/ds-theme';
import { Ref } from 'react';
import { ComponentWithAs, forwardRefWithAs, PropsWithAs } from '../as';
import { Box, BoxProps } from '../Box/Box';

/**
 * @beta
 */
export type ContentProps = Omit<
  BoxProps,
  'paddingX' | 'paddingLeft' | 'paddingRight' | 'px' | 'pl' | 'pr' | 'css'
>;

const paddings = [
  'sp-16',
  'contentPaddingX',
  pxToRem(24),
  'sp-32',
  pxToRem(33),
  pxToRem(36),
] as BoxProps['px'];

function ContextComponent(
  props: PropsWithAs<ContentProps, 'div'>,
  ref: Ref<HTMLDivElement>
) {
  return (
    <Box
      bg="white"
      maxWidth={pxToRem(1600)}
      mx="auto"
      {...props}
      px={paddings}
      ref={ref}
    />
  );
}

/**
 * @beta
 */
export const Content: ComponentWithAs<ContentProps, 'div'> = forwardRefWithAs<
  ContentProps,
  'div'
>(ContextComponent);

Content.displayName = 'Content';
